import React from 'react';
import { TextField, Autocomplete, Chip } from '@mui/material';

interface CreateDropdownOptionsProps {
    label: string;
    newOptions: string[];
    setNewOptions: (options: string[]) => void;
};

const CreateDropdownOptions: React.FC<CreateDropdownOptionsProps> = ({ label, newOptions, setNewOptions }) => {
    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={newOptions}
            onChange={(_, newValue) => setNewOptions(newValue.filter(val => val.length > 0))}
            renderValue={(value: string[], getTagProps) =>
                value.map((option: string, index: number) => (
                    <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={label}
                />
            )}
        />
    );
};

export default CreateDropdownOptions;